<app-attachment class="circular no-border"
  [attachment]="profilePicture$ | async"
  [placeholder]="false"
  icon="pets"
  progressType="progress-spinner"
  diameter="64"
  (uploaded)="onChange($event)">
</app-attachment>
<app-uploader [options]="['camera']" [multiple]="false" (selectedFiles)="uploadFiles($event)"></app-uploader>